<div class="notification-box" (click)="clickOnBadge.emit($event)">
    <span class="notification-badge" [ngStyle]="{'top': top? (top + 'px') : '',
     'left': left? (left + 'px') : '',
     'right': right? (right + 'px') : '',
     'bottom': bottom? (bottom + 'px') : '',
     'width': additionalText? (additionalTextWidth + 'px') : ''}">
        {{value}}<span *ngIf="additionalText">&nbsp;{{additionalText}}</span><ng-container *ngTemplateOutlet="additionalContent"></ng-container>
    </span>
</div>